export enum UserRightsTypes {
  SYSADMIN = "1",
  ADMIN = "2",
  BASIC = "3",
  VIEW = "4",
}
